import {
  AdvancedImage,
  lazyload,
  placeholder,
  responsive,
} from '@cloudinary/react';
import { CloudinaryImage } from '@cloudinary/url-gen';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import {
  AppBar,
  Box,
  Collapse,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import Container from '@mui/material/Container';
import { alpha, styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getVideoMenu } from '../../api/menu';
import { navigation_admin, navigation_user } from '../../app-navigation';
import VideoKategoriaMenuButton from '../../components/video/video-kategoria/VideoKategoriaMenuButton';
import { useAuth } from '../../contexts/auth';
import ColorModeIconDropdown from '../../themes/MuiTheme/ColorModeIconDropdown';

export default function AppBarMain({ title }) {
  const logo = new CloudinaryImage('tanyaegyetem/TE_logo_transparent', {
    cloudName: 'scriptantia',
  });
  const navigate = useNavigate();
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [videoMenu, setVideoMenu] = useState([]);
  const [mainMenu, setMainMenu] = useState([]);
  const [openMenus, setOpenMenus] = React.useState({});

  useEffect(() => {
    async function fetchMenu() {
      const menuData = await getVideoMenu();
      if (menuData && user.activeSubscriptions.length !== 0) {
        setVideoMenu(menuData);
      }
      setMainMenu(
        user.userData.user.adm === 1 ? navigation_admin : navigation_user
      );
    }
    fetchMenu();
  }, []);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setMenuOpen(open);
  };

  const toggleMenu = (key) => {
    setOpenMenus((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const StyledToolbar = styled(Toolbar)(({ theme }) => {
    return {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexShrink: 0,
      borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
      backdropFilter: 'blur(24px)',
      border: '1px solid',
      borderColor: (theme.vars || theme).palette.divider,
      backgroundColor: theme.vars
        ? theme.vars.palette.background.appBar
        : alpha(theme.palette.background.appBar, 0.9),
      boxShadow: (theme.vars || theme).shadows[1],
      padding: '8px 16px',
    };
  });

  return (
    <AppBar
      width='100%'
      enableColorOnDark
      sx={{
        boxShadow: 0,
        bgcolor: 'transparent',
        backgroundImage: 'none',
        mt: 'calc(var(--template-frame-height, 0px) + 28px)',
        position: {
          xs: 'relative', // Kis képernyőn nem rögzített
          md: 'fixed', // Közepes és nagy képernyőn rögzített
        },
      }}
    >
      <Container maxWidth='lg'>
        <StyledToolbar variant='dense' disableGutters>
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              //gap: 1,
              px: 0,
              alignItems: 'center', // Középre igazítás vertikálisan
              justifyContent: 'space-between',
            }}
          >
            <Box flexShrink={1} maxWidth='20%'>
              <AdvancedImage
                cldImg={logo}
                style={{ width: '70px', height: 'auto' }} // Automatikus méretezés
                plugins={[
                  lazyload(),
                  responsive({ steps: [30, 50, 60] }),
                  placeholder(),
                ]}
                onClick={() => navigate('/home')}
              />
            </Box>

            {videoMenu && videoMenu.length > 0 ? (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: '1fr ',
                    sm: '1fr 1fr',
                    md: '1fr 1fr 1fr  ',
                    lg: '1fr 1fr 1fr 1fr 1fr 1fr',
                  },
                  gap: 0,

                  py: 1,
                  px: 1,
                  justifyContent: 'center',
                }}
              >
                {videoMenu.map((item, index) => (
                  <VideoKategoriaMenuButton
                    key={index * 100}
                    kategoriaNev={item.text}
                    katKey={item.key}
                  />
                ))}
              </Box>
            ) : (
              <Typography
                variant='h6'
                color='primary'
                sx={{ flexGrow: 1, textAlign: 'center' }}
              >
                {title}
              </Typography>
            )}
            <Box
              edge='start'
              sx={{
                gap: 1,
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr ',
                  sm: '1fr 1fr',
                  md: '1fr 1fr 1fr 1fr ',
                },
              }}
            >
              {user.userData.user.adm === 1 && (
                <IconButton
                  color='info'
                  aria-label='menu'
                  onClick={toggleDrawer(true)}
                >
                  <MenuIcon />
                </IconButton>
              )}

              <IconButton
                color='primary'
                variant='contained'
                aria-label='profile'
                onClick={() => navigate('/profile')}
              >
                <AccountCircleIcon />
              </IconButton>
              <IconButton
                color='info'
                aria-label='menu'
                onClick={() => navigate('/logout')}
              >
                <LogoutIcon />
              </IconButton>
              <ColorModeIconDropdown size='medium' />
            </Box>
          </Box>
        </StyledToolbar>
      </Container>
      {/* Oldalsó menü (Drawer) */}
      <Drawer anchor='right' open={menuOpen} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250 }} role='presentation'>
          <List>
            {mainMenu.map((item, index) => (
              <React.Fragment key={index}>
                <ListItem
                  button
                  onClick={
                    item.items
                      ? () => toggleMenu(item.key) // Ha van almenü, akkor csak nyit/zár
                      : () => {
                          navigate(item.path);
                          toggleDrawer(false)(); // Csak végső menüpontoknál zárja be
                        }
                  }
                >
                  <ListItemText primary={item.text} />
                  {item.items ? (
                    openMenus[item.key] ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )
                  ) : null}
                </ListItem>
                {item.items && (
                  <Collapse
                    in={openMenus[item.key]}
                    timeout='auto'
                    unmountOnExit
                  >
                    <List component='div' disablePadding>
                      {item.items.map((subItem, subIndex) => (
                        <ListItem
                          button
                          key={subIndex}
                          sx={{ pl: 4 }}
                          onClick={() => {
                            navigate(subItem.path);
                            toggleDrawer(false)(); // Csak itt zárjuk be
                          }}
                        >
                          <ListItemText primary={subItem.text} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>
    </AppBar>
  );
}
